var map = {
	"./PAIR_ABI.json": 1171,
	"./common/BTCB.json": 830,
	"./common/BUSD.json": 831,
	"./common/BinarySubscription.json": 832,
	"./common/BitopexToken.json": 833,
	"./common/BusinessParcel.json": 834,
	"./common/CashFT.json": 835,
	"./common/ETH.json": 836,
	"./common/FileCoin.json": 837,
	"./common/GymAgregator.json": 838,
	"./common/GymNetwork.json": 839,
	"./common/GymRouter.json": 840,
	"./common/GymStreetFarming.json": 841,
	"./common/GymStreetLevelPool.json": 842,
	"./common/MLM.json": 843,
	"./common/MiningSC.json": 844,
	"./common/MlmQualification.json": 845,
	"./common/MonthlyTaxPool.json": 846,
	"./common/MysteryBox.json": 847,
	"./common/NetGymStreet.json": 848,
	"./common/NftReflection.json": 849,
	"./common/PANCAKE_FACTORY.json": 850,
	"./common/PancakeRouter.json": 851,
	"./common/PendingCommissionActivation.json": 852,
	"./common/SignatureValidatorUM.json": 853,
	"./common/SinglePool.json": 854,
	"./common/SinglePoolPendingCommission.json": 855,
	"./common/TurnoverPool.json": 856,
	"./common/USDT.json": 857,
	"./common/Vaults.json": 858,
	"./common/WBNB.json": 859,
	"./gymstreet/MinerNFT.json": 1645,
	"./gymstreet/Municipality.json": 1646,
	"./gymstreet/StandardParcel.json": 1647,
	"./kabutocho/MinerNFT.json": 1648,
	"./kabutocho/Municipality.json": 1649,
	"./kabutocho/StandardParcel.json": 1650
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 829;